module.exports = __webpack_public_path__ + "img/login.67d429bf.png";